// useLegalEntityLine.ts — CORE-1934
//
// Строка реквизитов в подвалах приложения и лендинга. Юрлицо выбирается тем же
// правилом, что редакция пользовательского соглашения (CORE-1555): российский
// контур — АО, иначе — AGAPE.IO Limited с адресом из английских документов
// (`screens/legal/legalDocsEn.tsx`). Язык экрана на выбор не влияет — только
// на язык самой строки.

import { useI18n } from '../i18n';
import { isForeignJurisdiction, readJurisdictionSignals } from '../utils/legalJurisdiction';

export function useLegalEntityLine(): string {
  const { t, i18n } = useI18n('common');
  const foreign = isForeignJurisdiction(readJurisdictionSignals(i18n.language));
  return t(foreign ? 'footer.legalEntityIntl' : 'footer.legalEntity');
}

/**
 * CORE-1567 — человек вне российского контура (то же правило). По нему подвалы
 * решают, показывать ли документы только для зарубежного контура
 * (`legal/docIds` → `isLegalDocShown`).
 */
export function useForeignJurisdiction(): boolean {
  const { i18n } = useI18n('common');
  return isForeignJurisdiction(readJurisdictionSignals(i18n.language));
}
